import clsx, { ClassValue } from 'clsx'
import { ReactNode } from 'react'

export type BoxChartProps = {
  title?: string
  subTitle?: string
  headerComponent?: ReactNode
  children: ReactNode
  aside?: ReactNode
  asideClassName?: ClassValue
  className?: ClassValue
}

export function BoxChart (props: BoxChartProps) {
  const { title, subTitle, headerComponent, children, className, aside, asideClassName } = props
  return (
    <div className={clsx('flex flex-col border-2 rounded-xl w-full overflow-hidden', className)}>
      {title && (
        <div className={clsx('flex flex-row border-b-1 overflow-hidden p-4 justify-between', headerComponent && 'min-h-[100px]')}>
          <div className={clsx('flex flex-col', !headerComponent && 'w-full', !subTitle && 'justify-center')}>
            <h2 className="text-2xl font-semibold">{title}</h2>
            <h2 className="text-sm font-light text-gray-500">{subTitle}</h2>
          </div>
          {headerComponent &&
            <div className='flex justify-end'>
              {headerComponent}
            </div>
          }
        </div>
      )}
      <div className="flex flex-row w-full h-full overflow-hidden">
        {aside &&
          <div className={clsx('bg-gray-100 p-6 flex flex-col', asideClassName || 'w-1/3')}>
            {aside}
          </div>}
        <div className="p-3 w-full h-full">{children}</div>
      </div>
    </div>
  )
}
